import { render, staticRenderFns } from "./SelectionList.vue?vue&type=template&id=dc387ca0"
import script from "./SelectionList.vue?vue&type=script&lang=js"
export * from "./SelectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports